import styled from 'styled-components'

export default styled.div`
  position: absolute;
  transform: translateX(-50%);
  width: auto;
  height: 64px;
  padding: 13px 20px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  background: ${props => props.theme.colors.white};

  z-index: 4;
`



// WEBPACK FOOTER //
// ./src/components/FrameBox/index.js